import { Guid } from "guid-typescript";
import { MeterReading } from "src/app/interfaces/Index";
import { Service } from "./Service";

const endpoint = "MeterReading";
export const MeterReadingService = {
	endpoint,
	createSingle: async (data: MeterReading) => await Service.createSingle(endpoint, data),
	deleteSingleById: async (id: number) => await Service.deleteSingleById(endpoint, id),
	getAll: async () => await Service.getAll(endpoint),
	getSingleById: async (id: number) => await Service.getSingleById(endpoint, id),
	getSingleByLookupId: async (id: Guid) => await Service.getSingleByLookupId(endpoint, id),
	updateSingleById: async (id: number, data: MeterReading) => await Service.updateSingleById(endpoint, id, data)
}